//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "./store"

import PanelDetailProject from './PanelDetailProject.vue'

export default {
  name: 'PanelDetail',
  components: {
    PanelDetailProject,
  },
  data() {
    return {
      showMe: 0,
      projects: [],
    }
  },
  mounted() {
    // inititalize slider
    $("#panel-detail").slick({
      asNavFor: '#slick-slider',
    })

    // listen to clicks on popup
    this.$root.$on('clickOnPopUp', this.showDetails)
    
    // listen to clicks on markers and overlapping markers
    this.$root.$on('hideDetailPanel', this.closePanel)
  },
  methods: {
    closePanel() {
      this.showMe=false
      this.slickUpdate()
    },
    showDetails(args) {
      // let project_id = args.project_id
      let related_projects = args.related_projects

      // make sure the panel is visible
      this.$parent.currentTab=this.$parent.tabs[1]
      this.$parent.panelsVisible=true
      
      this.projects.length = 0

      // get the projects from the store
      related_projects.forEach((r) => {
        let m = store.initialMarkerData.find(x => x._mapping_project_id == r)
        if (m !== undefined) {           
          this.projects.push(m)
        }
      })
     
      this.slickUpdate()
      
      if(this.projects.length==1) {
        $('#panel-slider-container').removeClass('has-pager-visible')
      } else {
        $('#panel-slider-container').addClass('has-pager-visible')
      }
      
      this.showMe = true

    },

    slickUpdate() {
      this.$nextTick(() => {
        $('#panel-detail').slick('slickRemove', 'removeAll')
        
        $('.addToSlider:not(.slick-cloned)').each(function(){
          $('#panel-detail').slick('slickAdd',$(this));
        })
    
        // refresh is necessary for syncing the detailpanel slider
        $('#slick-slider').slick('refresh');
      })
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelDetail.vue